module.exports = __webpack_public_path__ + "static/media/issuer_portal.833eb5dc.png";